import {
    Global,
	CookieBar,
    LangSwitcher,
	Header,
	HeaderSearch,
    Navbar,
    Toggle,
    Slider,
    Tabs,
    Dropdown,
    PanelList,
    ProductList,
	ProductQuantity,
    CheckoutForm,
} from './frontend/app/components';
import App from './app';

App( {
    config: window.ctheme_site_settings,
    components: [
        Global,
		CookieBar,
        LangSwitcher,
		Header,
        HeaderSearch,
        Navbar,
        Toggle,
        Slider,
		Tabs,
		Dropdown,
        PanelList,
		ProductList,
		ProductQuantity,
        CheckoutForm,
    ],
} );
